import { Flex } from "@chakra-ui/react";
import KioskLoadingAnimation from "./KioskLoadingAnimation";

/** Centered full-viewport loading animation for routes that can't decide yet. */
export default function FullPageLoading() {
  return (
    <Flex minH="100vh" align="center" justify="center">
      <KioskLoadingAnimation />
    </Flex>
  );
}
